'use client';

import { cn } from '@coas/ui/lib';
import { memo, useCallback } from 'react';
import IconTrash from 'src/shared/assets/icons/trash.svg';
import { useRemoveFromWishlist } from '../model/hooks';

type RemoveFromWishlistProps = {
    id: string;
    className?: string;
};

export default memo(({ id, className }: RemoveFromWishlistProps) => {
    const { remove, isPending } = useRemoveFromWishlist(id);

    const handleRemove = useCallback(() => {
        if (isPending) return;
        remove();
    }, [remove, isPending]);

    return (
        <button
            type={'button'}
            className={cn('outline-offset-2 outline-neutral-500 focus-visible:outline', className)}
            onClick={handleRemove}
        >
            <IconTrash className={'h-full w-full stroke-neutral-500'} />
        </button>
    );
});
